import React from 'react';
import { Card, CardMedia, CardContent, Box, Typography, IconButton, Switch, styled, useTheme, Tooltip, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import "./style.css";
import { typeIcons } from 'utils/constant';
import CustomTypography from 'components/Fileds/CustomTypography';
import foodItemIcon from "assests/food-item-icon.svg";
import IOSSwitch from 'components/Fileds/IOSSwitch';
import { useSelector } from 'react-redux';
import { formatCurrency } from 'utils/function';

const FoodItemCard = ({ data, enabled, onEdit, onDelete, onToggle, toggleDisabled, onViewAddOns }) => {
    const theme = useTheme();
    const userData = useSelector((state) => state?.posData)

    // return (
    //     <Box className='food-items-main-container'>
    //         <Box className='food-items-container'>
    //             <Box>
    //                 <Box className='overlay-container' />
    //                 <img src={`${process.env.REACT_APP_API_ROUTE}/files/${data?.image}`}
    //                     alt={data?.name} className='food-item-img'
    //                 />
    //                 <Box
    //                     component="img"
    //                     src={typeIcons[data.item_type]}
    //                     alt={data.item_type}
    //                     className='food-type-icon'
    //                 />

    //                 {data?.groups?.length > 0 && (
    //                     <Box component="span" className='add-ons-label' onClick={() => onViewAddOns(data)} sx={{ cursor: 'pointer !important' }}>
    //                         Add-Ons
    //                     </Box>
    //                 )}
    //             </Box>
    //             <Box className='d-flex food-items-content'>
    //                 <Box>
    //                     {/* <CustomTypography
    //                         variant="subtitle2"
    //                         label={data?.name}
    //                         sx={{ fontSize: '18px', fontWeight: 500, color: theme.palette.typographyLabel.main, lineHeight: 'normal' }}
    //                     /> */}
    //                     <Tooltip title={data?.name} arrow>
    //                         <Box sx={{ maxWidth: '300px' }}>
    //                             <CustomTypography
    //                                 variant="subtitle2"
    //                                 label={data?.name}
    //                                 sx={{
    //                                     fontSize: '18px',
    //                                     fontWeight: 500,
    //                                     color: theme.palette.typographyLabel.main,
    //                                     lineHeight: 'normal',
    //                                     whiteSpace: "nowrap",
    //                                     overflow: "hidden",
    //                                     textOverflow: "ellipsis",
    //                                     cursor: "pointer"
    //                                 }}
    //                             />
    //                         </Box>
    //                     </Tooltip>
    //                     <Box className='d-flex align-items-center' >
    //                         <img src={foodItemIcon} alt='icon' style={{ marginRight: '5px', width: '18px', height: '18px' }} />
    //                         <CustomTypography
    //                             variant="body2"
    //                             label={data?.category?.name}
    //                             sx={{ fontSize: '16px', fontWeight: 400, color: theme.palette.drawermenuitem.main, mb: 0, lineHeight: 'normal' }}
    //                         />
    //                     </Box>
    //                 </Box>

    //                 <Box className='price-action-section d-flex align-items-center justify-content-between'>
    //                     <CustomTypography
    //                         label={formatCurrency(data?.price?.toFixed(2) || 0, userData.vendor.currency)}
    //                         variant={"body1"}
    //                         sx={{
    //                             fontWeight: 400,
    //                             fontSize: '18px',
    //                             color: theme.palette.highlight.main,
    //                             mb: 0
    //                         }}
    //                     />

    //                     <Box className='d-flex align-items-center' sx={{ gap: '5px' }}>
    //                         <IconButton onClick={onEdit} size="small">
    //                             <EditIcon fontSize="small" sx={{ color: '#1297DE' }} />
    //                         </IconButton>
    //                         <IconButton onClick={onDelete} size="small">
    //                             <DeleteIcon fontSize="small" sx={{ color: '#FF0202', mr: 0.5 }} />
    //                         </IconButton>
    //                         <IOSSwitch checked={enabled} onChange={onToggle} disabled={toggleDisabled} />
    //                     </Box>
    //                 </Box>
    //             </Box>

    //         </Box>
    //     </Box>
    // );

    return (
        <Box className='food-items-main-container'>
            <Box className='food-items-container'>
                <Box className='food-items-image-wrapper'>
                    <img
                        src={`${process.env.REACT_APP_API_ROUTE}/files/${data?.image}`}
                        alt={data?.name}
                        className='food-item-img'
                    />
                    <Box className='overlay-container' />
                    <Box
                        component="img"
                        src={typeIcons[data.item_type]}
                        alt={data.item_type}
                        className='food-type-icon'
                    />

                    {data?.groups?.length > 0 && (
                        <Box
                            component="span"
                            className='add-ons-label'
                            onClick={() => onViewAddOns(data)}
                        >
                            Add-Ons
                        </Box>
                    )}

                    <Box className='food-price-badge'
                        sx={{
                            // bgcolor: enabled ? '#EEF8EE' : "#75757514",
                            // bgcolor: "transparent",
                            color: enabled ? '#1F9619' : "#757575",
                            fontWeight: 600,
                            borderRadius: '20px',
                        }}>
                        {enabled ? 'Active' : 'Inactive'}
                    </Box>
                </Box>

                <Box className='d-flex food-items-content'>
                    <Box>
                        <Tooltip title={data?.name} placement="bottom-start" arrow>
                            <Box sx={{ maxWidth: '100%' }}>
                                <CustomTypography
                                    variant="subtitle2"
                                    label={data?.name}
                                    sx={{
                                        fontSize: '17px',
                                        fontWeight: 600,
                                        color: theme.palette.typographyLabel.main,
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        cursor: "pointer",
                                        mb: 0.75,
                                    }}
                                />
                            </Box>
                        </Tooltip>
                        <Box className='food-category-chip'>
                            <img src={foodItemIcon} alt='icon' />
                            {data?.category?.name}
                        </Box>
                    </Box>

                    <Box className='price-action-section d-flex align-items-center justify-content-between'>
                        <CustomTypography
                            label={formatCurrency(data?.price?.toFixed(2) || 0, userData.vendor.currency)}
                            variant={"body1"}
                            sx={{
                                fontWeight: 600,
                                fontSize: '17px',
                                color: theme.palette.highlight.main,
                                mb: 0
                            }}
                        />

                        <Box className='d-flex align-items-center' sx={{ gap: '4px' }}>
                            <Tooltip title="Edit" arrow>
                                <IconButton onClick={onEdit} size="small" sx={{ bgcolor: '#eff8ff', '&:hover': { bgcolor: '#dbeefe' } }}>
                                    <EditIcon fontSize="small" sx={{ color: '#1297DE', fontSize: 16 }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete" arrow>
                                <IconButton onClick={onDelete} size="small" sx={{ bgcolor: '#fef2f2', '&:hover': { bgcolor: '#fee2e2' } }}>
                                    <DeleteIcon fontSize="small" sx={{ color: '#FF0202', fontSize: 16 }} />
                                </IconButton>
                            </Tooltip>
                            <IOSSwitch checked={enabled} onChange={onToggle} disabled={toggleDisabled} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default FoodItemCard;